import { createContext, ReactNode, useContext } from "react";
import { HttpStatusManager } from "./http-status-manager";

const HttpStatusContext = createContext<HttpStatusManager | null>(null);

export const HttpStatusProvider = (
  { manager, children }: { manager: HttpStatusManager; children: ReactNode }
) => <HttpStatusContext.Provider value={manager}>{children}</HttpStatusContext.Provider>;

export const HttpStatus = ({ code }: { code: number }) => {
  const manager = useContext(HttpStatusContext);
  manager?.setStatus(code);
  return null;
};
